module.exports = __webpack_public_path__ + "img/APM.24053fe4.png";